export default "__VITE_ASSET__hTmEe8GU__"